import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-management-roof]',
    templateUrl: './management-roof.component.html',
    styleUrl: './management-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ManagementRoofComponent {
  type = input<BuildingType>();

}
